import { FC, useEffect, useState } from "react";
import "./privacy.css";
import { useNavigate, useNavigation, useParams } from "react-router-dom";
import api from "../../../services/api";
import useAuth from "../../../hooks/useAuth";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { Loading } from "../../../components/Loading";
import Swal from "sweetalert2";

const Privacy: FC = () => {
  const [termo, setTermo] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getToken } = usePluginspace();
  const { pluginspace_id } = useParams();
  const navigate = useNavigate();
  const { loginInfo } = useAuth();

  const atualizar = async () => {
    setLoading(true);

    await api
      .put(
        `/api/customer/${loginInfo.id}`,
        {
          optinWhatsapp: termo,
          addresses: [],
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        const update = response.data;
        if (update.success) {
          Swal.fire({
            icon: "success",
            title: "Sucesso!",
            text: "Termos atualizados com sucesso.",
          }).then(() => navigate(`/${pluginspace_id}/profile`));
        } else {
          Swal.fire({
            icon: "error",
            title: "Erro ao atualizar senha!",
            text: "Termos atualizados com sucesso.",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao atualizar senha!",
          text: "Termos atualizados com sucesso.",
        });
      });
  };

  const getCustomerConfig = async () => {
    setLoading(true);
    try {
      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: loginInfo.identifier,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response: any) => {
          setLoading(false);
          if (response.data.data.length > 0) {
            const data = response.data.data[0];
            setTermo(data.optinWhatsapp);
          }
        })
        .catch((err: any) => {
          setLoading(false);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
      return;
    }
  };

  useEffect(() => {
    getCustomerConfig();
  }, []);

  return (
    <>
      {loading ? (
        <div style={{ width: "100%", height: "calc(100vh)" }}>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="privacyContent">
          <div className="infoHeader">
            <h4>Configurações da conta</h4>
          </div>
          <div className="infoInputs">
            {/* WhatsApp */}
            <div className="checkbox">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={termo}
                  onChange={(event) => setTermo(event.target.checked)}
                />
                <span className="slider round"></span>
              </label>
              <div className="headers">
                <span>Aceito receber mensagem via Whats App</span>
              </div>
            </div>

            <div className="buttomCadastro">
              <button
                style={{
                  background: "#6E7586",
                  color: "white",
                  border: "none",
                }}
                onClick={() => atualizar()}
              >
                Salvar
              </button>
            </div>
          </div>

          <div className="excluir">
            <div className="excluirHeader">
              <h4>Excluir conta</h4>
            </div>
            <div className="excluirContent">
              <span>
                <button id="linkButton" onClick={() => navigate("delete")}>
                  Clique aqui{" "}
                </button>
                para visualizar os termos de encerramento e excluir a sua conta.
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export { Privacy };
